import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  Typography,
  DialogActions,
  Button
} from '@mui/material';


function CompletionDialog({
  handleClose,
  isOpen,
  handleCompleteEncounterReview
}) {

  return (
    <Dialog
      onClose={handleClose}
      open={isOpen}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
    >
      <Box sx={{ padding: '20px' }}>
        <Typography variant="h6">Encounter Review Completion</Typography>
        <Typography variant="body">
          Are you sure you want to complete this review? The encounter will no
          longer be accessible for review once it has been completed.
        </Typography>
      </Box>
      <DialogActions>
        <Button
          onClick={() => {
            handleCompleteEncounterReview()
              .then(handleClose());
          }}
        >
          Ok
        </Button>
        <Button onClick={handleClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CompletionDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleCompleteEncounterReview: PropTypes.func.isRequired
};

export { CompletionDialog };
